import React, { useMemo } from "react";
const spinnerStyle = {
  width: 14,
  height: 14,
  borderWidth: 2,
  marginTop: 8,
} as const;

const cardStyle = {
  padding: "8px 12px",
  border: "1px solid #e6e9f0",
  borderRadius: 8,
  background: "#fff",
} as const;

const labelStyle = { fontSize: 11, lineHeight: 1.2 } as const;

const valueClassName = "fw-bold d-flex align-items-center";
const valueStyle = { fontSize: 15, gap: 6 } as const;

const FilterStatisticsCards = ({
  hasApplied,
  loading,
  recordsTotal,
  recordsFiltered,
}: any) => {
  const { totalDisplay, filteredDisplay, percentDisplay, statsLoading } =
    useMemo(() => {
      const total =
        recordsTotal !== null ? recordsTotal.toLocaleString() : "--";
      const filtered =
        recordsFiltered !== null ? recordsFiltered.toLocaleString() : "--";
      const percent =
        recordsTotal === 0
          ? "0%"
          : recordsTotal !== null &&
            recordsFiltered !== null &&
            recordsTotal > 0
          ? `${((recordsFiltered / recordsTotal) * 100).toFixed(4)}%`
          : "--";
      const loadingState =
        hasApplied &&
        (loading || recordsTotal === null || recordsFiltered === null);

      return {
        totalDisplay: total,
        filteredDisplay: filtered,
        percentDisplay: percent,
        statsLoading: loadingState,
      };
    }, [hasApplied, loading, recordsTotal, recordsFiltered]);

  if (!hasApplied) return null;

  return (
    <>
      <div style={cardStyle}>
        <div className="text-muted" style={labelStyle}>
          Filters users
        </div>
        <div className={valueClassName} style={valueStyle}>
          {statsLoading ? (
            <span
              className="spinner-border spinner-border-sm text-primary"
              role="status"
              aria-hidden="true"
              style={spinnerStyle}
            ></span>
          ) : (
            filteredDisplay
          )}
        </div>
      </div>
      <div style={cardStyle}>
        <div className="text-muted" style={labelStyle}>
          Total users
        </div>
        <div className={valueClassName} style={valueStyle}>
          {statsLoading ? (
            <span
              className="spinner-border spinner-border-sm text-primary"
              role="status"
              aria-hidden="true"
              style={spinnerStyle}
            ></span>
          ) : (
            totalDisplay
          )}
        </div>
      </div>

      <div style={cardStyle}>
        <div className="text-muted" style={labelStyle}>
          Coverage
        </div>
        <div className={valueClassName} style={valueStyle}>
          {statsLoading ? (
            <span
              className="spinner-border spinner-border-sm text-primary"
              role="status"
              aria-hidden="true"
              style={spinnerStyle}
            ></span>
          ) : (
            percentDisplay
          )}
        </div>
      </div>
    </>
  );
};

export default FilterStatisticsCards;
